/* GROUNDWORK — motion & behavior
   Everything eased. Master reduce-motion toggle freezes morph + float. */
(function(){
  'use strict';
  var root = document.documentElement;
  var RM_KEY = 'gw-reduce-motion';
  var osReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reduce motion state ---- */
  function readRM(){
    var stored = null;
    try { stored = localStorage.getItem(RM_KEY); } catch(e){}
    if (stored === '1') return true;
    if (stored === '0') return false;
    // fall back to theme default flag on <html data-rm-default>
    if (root.getAttribute('data-rm-default') === 'true') return true;
    return osReduce;
  }
  function applyRM(on){
    root.classList.toggle('reduce-motion', !!on);
    document.querySelectorAll('.rm-toggle').forEach(function(b){ b.setAttribute('aria-pressed', on ? 'true':'false'); });
    if (on){ // freeze reveals — show them all
      document.querySelectorAll('.rise').forEach(function(el){ el.classList.add('is-in'); });
    }
  }
  var rm = readRM();
  applyRM(rm);

  document.addEventListener('click', function(e){
    var t = e.target.closest('.rm-toggle');
    if (!t) return;
    rm = !rm;
    try { localStorage.setItem(RM_KEY, rm ? '1':'0'); } catch(err){}
    applyRM(rm);
  });

  /* ---- reveal on scroll (fade + float) ---- */
  var rises = Array.prototype.slice.call(document.querySelectorAll('.rise'));
  if ('IntersectionObserver' in window && !rm){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    rises.forEach(function(el){ io.observe(el); });
  } else {
    rises.forEach(function(el){ el.classList.add('is-in'); });
  }

  /* ---- blur-up images ---- */
  document.querySelectorAll('img.blurup').forEach(function(img){
    if (img.complete && img.naturalWidth){ img.classList.add('is-loaded'); }
    else { img.addEventListener('load', function(){ img.classList.add('is-loaded'); }); }
  });

  /* ---- count-up stats ---- */
  function countUp(el){
    var target = parseFloat(el.getAttribute('data-count') || '0');
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var decimals = (target % 1 !== 0) ? 1 : 0;
    if (rm){ el.textContent = prefix + target.toLocaleString() + suffix; return; }
    var dur = 1600, start = null;
    function step(ts){
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = prefix + (decimals ? val.toFixed(1) : Math.round(val).toLocaleString()) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window){
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){ countUp(en.target); cio.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    counters.forEach(function(el){ cio.observe(el); });
  } else { counters.forEach(countUp); }

  /* ---- read progress bar ---- */
  var bar = document.querySelector('.read-progress');
  if (bar){
    var article = document.querySelector('[data-article-body]') || document.body;
    function onScroll(){
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total,1));
      bar.style.width = (total > 0 ? (scrolled / total) * 100 : 0) + '%';
    }
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---- mobile nav ---- */
  var burger = document.querySelector('.burger');
  var nav = document.querySelector('.nav');
  if (burger && nav){
    burger.addEventListener('click', function(){
      var open = nav.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true':'false');
      document.body.style.overflow = open ? 'hidden':'';
    });
    nav.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        nav.classList.remove('open'); burger.classList.remove('open');
        burger.setAttribute('aria-expanded','false'); document.body.style.overflow='';
      });
    });
  }

  /* ---- comment form focus (jump to note) ---- */
  if (location.hash === '#comment-note'){
    var note = document.querySelector('.form-note');
    if (note) note.scrollIntoView({ behavior: rm ? 'auto':'smooth', block:'center' });
  }
})();
